
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/forex/sell-forex",
      function () {
        return require("private-next-pages/help/forex/sell-forex.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/forex/sell-forex"])
      });
    }
  